import React, { useState, useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';

export default function LandingLayout({ setView, user }) {
  const { tenantConfig } = useTheme();

  // Track viewport responsiveness dynamically
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (!tenantConfig) return null;

  const backgroundStyle = tenantConfig.background_url
    ? { backgroundImage: `url(${tenantConfig.background_url})`, backgroundSize: 'cover', backgroundPosition: 'center' }
    : { background: 'linear-gradient(135deg, #1f2937 0%, #111827 100%)' };

  return (
    <main 
      style={{
        ...backgroundStyle,
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: isMobile ? '40px 15px' : '60px 20px',
        color: 'var(--text-main)',
        textAlign: 'center',
        minHeight: '70vh'
      }}
    >
      <div 
        style={{
          width: isMobile ? '95%' : '600px',
          maxWidth: '100%',
          background: 'var(--panel-bg)',
          border: '1px solid var(--border-color)',
          borderRadius: '12px',
          padding: isMobile ? '24px 20px' : '40px',
          backdropFilter: 'blur(8px)',
          boxShadow: 'var(--card-shadow)',
          boxSizing: 'border-box'
        }}
      >
        <h2 style={{ 
          fontSize: isMobile ? '24px' : '32px', 
          fontWeight: '700', 
          marginBottom: '16px',
          color: 'var(--primary-color)',
          letterSpacing: '-1px',
          lineHeight: '1.2'
        }}>
          {user ? `Welcome Back to ${tenantConfig.brand_name}` : `Welcome to ${tenantConfig.brand_name}`}
        </h2>
        
        {user && (
          <div style={{
            display: 'inline-block',
            backgroundColor: '#21262d',
            border: '1px solid #30363d',
            borderRadius: '6px',
            padding: '6px 12px',
            fontSize: '13px',
            color: '#58a6ff',
            marginBottom: '20px'
          }}>
            Authorized Scope Clearance: <strong>{user.role}</strong>
          </div>
        )}

        <p style={{ 
          fontSize: isMobile ? '14px' : '16px', 
          lineHeight: '1.6', 
          color: 'var(--text-mute)',
          marginBottom: '32px'
        }}>
          {user 
            ? `You are authenticated under the domain ${tenantConfig.domain_name} as an approved ${user.role.replace('_', ' ').toLowerCase()}. Use the button below to coordinate operations.`
            : `This platform is dynamically configured for the domain ${tenantConfig.domain_name}. All logos, branding schemas, color selections, and server-side assets have been dynamically compiled for this brand instance.`
          }
        </p>

        <button 
          onClick={() => {
            if (user) {
              alert(`Navigating to ${tenantConfig?.brand_name || 'dashboard'} for ${user.email}...`);
            } else {
              setView('auth');
            }
          }}
          style={{
            backgroundColor: 'var(--primary-color)',
            color: '#ffffff',
            padding: isMobile ? '10px 24px' : '12px 30px',
            fontSize: isMobile ? '13px' : '15px',
            fontWeight: '600',
            border: 'none',
            borderRadius: '6px',
            cursor: 'pointer',
            boxShadow: '0 4px 14px var(--accent-color)',
            transition: 'opacity 0.2s',
            width: isMobile ? '100%' : 'auto'
          }}
          onMouseOver={(e) => e.target.style.opacity = '0.9'}
          onMouseOut={(e) => e.target.style.opacity = '1'}
        >
          {user ? 'Open Campaign Dashboard' : (tenantConfig.allow_public_signup ? 'Onboard Now / Register' : 'Sign In to Portal')}
        </button>
      </div>
    </main>
  );
}
